import Vue from 'vue'
import store from './store'
import * as filters from './filters'
import * as injectables from './injectables'
import constants from "@/constants";
const { RESPONSE_CODES, IDENTITY_ERROR_MESSAGE } = constants;
import config from "@/config.js";
import directives from "./directives";
import routeList from './routeList'
import jwtDecode from "jwt-simple";
import moment from "moment";
import axios from "axios";
import Repository from '@/repositories/marketing'
import AccountRepository from '@/repositories/accounts'
import ConnectorRepository from '@/repositories/connectorApp'

/**
 * @description injects all the filter in the vue instance globally
 */
export const injectFilters = () => {
  for (const key in filters) {
    Vue.filter(key, filters[key]);
  }
};

/**
 * Injects services and modules in the vue instance globally
 */

export const injectInjectables = () => {
  for (const key in injectables) {
    Vue.prototype[`$${key}`] = injectables[key];
  }
}

/**
 * Registers directives globally in the project
 */
export const registerDirectives = () => {
  for (const key in directives) {
    Vue.directive(key, directives[key]);
  }
};

/**
 * Redirects user to specified url in param
 * @param {String} url Web url 
 */
export const redirectToUrl = (url) => {
  window.location.href = url;
};


/**
 * cancelAxiosRequest
 * @description Cancels ongoing axions http request
 * @param {String} message Error message to be thrown
 */
export const cancelAxiosRequest = (message = "Request cancelled.") => {
  throw new axios.Cancel(message);
};

export const getCookie = (key) => {
  return getCookieValue(key);
};

function getCookieValue(key){
  if(document.cookie.indexOf(`${key}=`) < 0){return null}
  let value = decodeURIComponent(document.cookie.split(`${key}=`)[1].split(';')[0]);
  value = value.replace(/[+]/g, ' ')
  try{
    return JSON.parse(value)
  }catch(e){
    return value
  }
}

export const verifyJTI = (token) => {
  let jti = getCookieValue(config.IDENTITY_JTI_COOKIE_NAME);
  if(token == undefined || token == '' || !jti){
    if(!jti && window.location.port == "8080"){
      return true;
    }
    return false;
  }
 
  try{
    let tokenInfo = jwtDecode.decode(token, '', true)
    return (tokenInfo.jti === jti);
  }catch(err){ return false; }
}

/**
 * Determines that api response code is success (200) or not
 * @returns {Boolean} is success or not
 */
export const isSuccess = (responseCode) => RESPONSE_CODES.success === responseCode

/**
 * hasProp
 * @description Determines whether a nested object contains a property or not
 * @returns {Boolean}
 */
export const hasProp = (data, prop) => {
  if (!data || Object.keys(data) <= 0) return false;
  return Object.getOwnPropertyNames(data).includes(prop);
};

export const refreshToken = async() =>{
  const keycloak = Vue.prototype.$keycloak;
  var expiresIn = keycloak.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + keycloak.timeSkew;
  if(expiresIn < 15)
    await keycloak.updateToken(15)
}

export const toReauth = () => {
  const keycloak = Vue.prototype.$keycloak;
  keycloak.login({
    redirectUri: `${window.location.origin}`, // Redirects back to the app's root after login
  });
}

export const isDevEnv = () => {
  const { NODE_ENV } = process.env;
  return NODE_ENV === "development" || window.location.port == "8080";
};
/**
 * Set Bee Page builder credentials 
 */

export const verifyAccountCluster = (account) => {
  const cluster = account.cluster;
  const subdomain = cluster.replace("app-","");
  
  config.BEE_PAGE_CLIENT_ID = process.env.VUE_APP_BEE_PAGE_CLIENT_ID;
  config.BEE_PAGE_CLIENT_SECRET = process.env.VUE_APP_BEE_PAGE_CLIENT_SECRET;
  config.BEE_POPUP_CLIENT_ID = process.env.VUE_APP_BEE_POPUP_CLIENT_ID;
  config.BEE_POPUP_CLIENT_SECRET = process.env.VUE_APP_BEE_POPUP_CLIENT_SECRET;
  config.BEE_EMAIL_CLIENT_ID = process.env.VUE_APP_BEE_EMAIL_CLIENT_ID;
  config.BEE_EMAIL_CLIENT_SECRET = process.env.VUE_APP_BEE_EMAIL_CLIENT_SECRET;

  switch(cluster){
    case "api-ca1":
    case 'canada': 
      config.RAILS_BASE_URL = `https://api-ca1.maropost.com`;
      break;
    case "api-eu1":
    case 'europe':
      config.RAILS_BASE_URL = `https://api-eu1.maropost.com`;
      break;
    case 'app-staging':
    case 'app-uat':
    case 'app-sandbox':
        config.BEE_PAGE_CLIENT_ID = process.env.VUE_APP_BEE_PAGE_CLIENT_ID_APP;
        config.BEE_PAGE_CLIENT_SECRET = process.env.VUE_APP_BEE_PAGE_CLIENT_SECRET_APP;
        config.BEE_POPUP_CLIENT_ID = process.env.VUE_APP_BEE_POPUP_CLIENT_ID_APP;
        config.BEE_POPUP_CLIENT_SECRET = process.env.VUE_APP_BEE_POPUP_CLIENT_SECRET_APP;
        config.BEE_EMAIL_CLIENT_ID = process.env.VUE_APP_BEE_EMAIL_CLIENT_ID_APP;
        config.BEE_EMAIL_CLIENT_SECRET = process.env.VUE_APP_BEE_EMAIL_CLIENT_SECRET_APP;
        config.RAILS_BASE_URL = `https://${cluster}-web.maropost.com`;
      break;
    default:
      config.RAILS_BASE_URL = `https://${cluster}-web.maropost.com`;
  }
  const env = document.location.hostname.replace('.maropost.com', '')
  const prodClusters = ['app', 'cloud', 'cloud1', 'app-eu1', 'app-ca1', 'cendyn']
  if(prodClusters.includes(env)){
    config.CONNECTOR_APP_RAILS_BASE_URL = 'https://connector.maropost.com'
  }else{
    config.CONNECTOR_APP_RAILS_BASE_URL = `https://${subdomain}-connector.maropost.com`
  }

  Repository.defaults.baseURL = `${config.RAILS_BASE_URL}/v2/${account.id}`;
  AccountRepository.defaults.baseURL = `${config.RAILS_BASE_URL}/v2`;
  ConnectorRepository.defaults.baseURL = `${config.CONNECTOR_APP_RAILS_BASE_URL}/v1`;
}

export const routeMiddleware = (routeName) =>{
  verifyAccountCluster(store.getters['auth/account'].current)
  const route = routeList.find(r => r.name === routeName)
  if( route && route.meta && route.meta.allowedPlatform){
    let index = route.meta.allowedPlatform.findIndex(domain =>  config.RAILS_BASE_URL.includes(domain))
    return !(index == -1)
  }
  return true;
}

export const extractCluster = (url) =>{
  try{
    let obj = new URL(url);
    return obj.origin.replace(/\b(?:https:\/\/|-web|.maropost.com)\b/gi,'');
  }
  catch(err){
    return false;
  }
}

export const sanitiseAccountList = (accounts) => {
  if(!accounts || accounts == null || accounts == undefined) return [];
  return accounts.filter(item=>item!=null&&item.cluster=='staging').map(item => {
    item.uid = item.id;
    return item;
  })
}

export let sanitiseIntegrationURL = (url) => {
  if(!url) throw Error("sanitiseIntegrationURL url param is required")
  
  if (containsEncodedComponents(url))   url = decodeURIComponent(url)
  let redirectUrlPath  = new URL(url);
  return `${redirectUrlPath.pathname}${redirectUrlPath.search}`;
}


export function containsEncodedComponents(x) {
  return (decodeURI(x) !== decodeURIComponent(x));
}

export function getSelectedFilterDayDate(days) {
  const FORMAT = "YYYY-MM-DD";
  const dateType = days == 365 ? "year" : "month";

  const created_on_gteq = moment()
    .startOf(dateType)
    .format(FORMAT);

  const created_on_lteq = moment()
    .format(FORMAT);

  return {
    created_on_gteq,
    created_on_lteq
  };
}

export function replaceUnderscore(text = "") {
  return text.includes("_") ? text.replace(/_/i, " ") : text;
}